"use client";

import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import { TimeSlot } from "@/types/slots";
import { cn } from "@/lib/utils";
import { toZonedTime } from "date-fns-tz";

export function SlotBtn({
  slot,
  duration,
  timeZone,
  use24Hour,
  isCapacityPublic,
  onTimeSelect,
}: {
  slot: TimeSlot;
  duration: number;
  timeZone: string;
  use24Hour: boolean;
  isCapacityPublic: boolean;
  onTimeSelect: (time: string, duration: number, time_zone: string) => void;
}) {
  return (
    <Button
      key={slot.time}
      variant="outline"
      onClick={() => onTimeSelect(slot.time, duration, timeZone!)}
      className={cn(
        "w-full justify-center font-normal relative",
        isCapacityPublic ? "py-8" : ""
      )}
      disabled={!slot.available}
    >
      <div className="flex flex-col items-center">
        <div
          className={cn("flex items-center gap-2", {
            "line-through": !slot.available,
          })}
        >
          <span
            className={`w-2 h-2 rounded-full ${
              slot.available ? "bg-green-500" : "bg-red-500"
            }`}
          />
          {format(
            toZonedTime(new Date(slot.time), timeZone),
            use24Hour ? "HH:mm" : "h:mm a"
          )}
        </div>
        {isCapacityPublic && (
          <p className="text-sm text-muted-foreground">
            {slot.available} spots left
          </p>
        )}
      </div>
    </Button>
  );
}
